import { all, call, put, takeLatest } from 'redux-saga/effects';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import {
  createUserEmailSignature,
  deleteUserEmailSignature,
  fetchUserEmailSignature,
  updateUserEmailSignature,
} from '../routines/userManagementRoutines';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';

const BASE_URL = `${envConfig.APIG_URL}user-management/users`;

export function* fetchUserEmailSignatureSaga({ payload: { userId } }) {
  try {
    const URL = `${BASE_URL}/${userId}/email-signature`;
    const response = yield call(request, URL);
    yield put(fetchUserEmailSignature.success(response));
  } catch (error) {
    yield put(fetchUserEmailSignature.failure(error));
  }
}

export function* createUserEmailSignatureSaga({ payload }) {
  try {
    const { userId, data } = payload;
    const URL = `${BASE_URL}/${userId}/email-signature`;
    const config = {
      method: 'POST',
      payload: data,
    };
    const response = yield call(request, URL, config);
    yield put(
      createUserEmailSignature.success({
        response,
        successMessage: SUCCESS_MESSAGES.CREATE_EMAIL_SIGNATURE,
      })
    );
  } catch (error) {
    yield put(createUserEmailSignature.failure(error));
  }
}

export function* updateUserEmailSignatureSaga({ payload }) {
  const { userId, data } = payload;
  try {
    const URL = `${BASE_URL}/${userId}/email-signature`;
    const config = {
      method: 'PATCH',
      payload: data,
    };
    const response = yield call(request, URL, config);
    yield put(
      updateUserEmailSignature.success({
        response,
        successMessage: SUCCESS_MESSAGES.UPDATE_EMAIL_SIGNATURE,
      })
    );
  } catch (error) {
    yield put(updateUserEmailSignature.failure(error));
  }
}

export function* deleteUserEmailSignatureSaga({ payload }) {
  try {
    const { userId } = payload;
    const URL = `${BASE_URL}/${userId}/email-signature/archive`;
    yield call(request, URL, { method: 'PATCH', payload: {} });
    yield put(
      deleteUserEmailSignature.success({
        successMessage: SUCCESS_MESSAGES.DELETE_EMAIL_SIGNATURE,
      })
    );
  } catch (error) {
    yield put(deleteUserEmailSignature.failure(error));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchUserEmailSignature.TRIGGER, fetchUserEmailSignatureSaga),
    takeLatest(createUserEmailSignature.TRIGGER, createUserEmailSignatureSaga),
    takeLatest(updateUserEmailSignature.TRIGGER, updateUserEmailSignatureSaga),
    takeLatest(deleteUserEmailSignature.TRIGGER, deleteUserEmailSignatureSaga),
  ]);
}
